export default "__VITE_ASSET__CPj1LCbK__"